import { gql } from '@apollo/client';

export default gql`
  mutation createBrand(
    $branch: String
    $name: String
    $nameAr: String
    $disabled: Boolean
    $additionId: String
  ) {
    createBrand(
      branch: $branch
      name: $name
      nameAr: $nameAr
      disabled: $disabled
      additionId: $additionId
    ) {
      ok
      message
      data
      error
    }
  }
`;
